import { createReducer } from '@reduxjs/toolkit';
import { setGeoSuggestLoading, setGeoSuggests } from './actions';
import { GeoSuggestUI } from './types';

interface GeoSuggestsState {
    suggests: GeoSuggestUI[];
    isLoading: boolean;
}

export const geoReducer = createReducer<GeoSuggestsState>(
    {
        suggests: [],
        isLoading: false,
    },
    (builder) => {
        builder
            .addCase(setGeoSuggestLoading, (draft, action) => {
                const { isLoading } = action.payload;

                draft.isLoading = isLoading;
            })
            .addCase(setGeoSuggests, (draft, action) => {
                draft.suggests = action.payload.suggests;
            });
    },
);
